module.exports = __webpack_public_path__ + "static/img/other_FAQ_pic04.282ffbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other_FAQ/other_FAQ_pic04.png
// module id = 556
// module chunks = 1